<template>
	<div>
		<div class="form-group">
			<label for="search-username">Sök på användarnamn</label>
			<input class="form-control" type="text" v-model="search" id="search-username">
		</div>
		<div v-if="chosen.length || results.length">
			<div v-if="results.length" class="mb-4">
				<div v-if="results.length !== chosen.length"><b>Hittade användare</b></div>
				<div v-for="result in results" v-if="chosen.indexOf(result) === -1" :key="result.id">
					<input type="checkbox" @click="toggleChosen(result)" :id="'result-' + result.id"> <label :for="'result-' + result.id">{{ result.name }}</label>
				</div>
			</div>
			<div v-if="chosen.length" class="mb-4">
				<div><b>Valda användare</b></div>
				<div v-for="user in chosen" :key="user.id">
					<input type="checkbox" v-model="user.toggled" @click="toggleChosen(user)" :id="'chosen-' + user.id"> <label :for="'chosen-' + user.id">{{ user.name }}</label>
					<input type="hidden" name="users[]" :value="user.id">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				chosen: [],
				results: [],
				search: '',
				timeout: null
			}
		},
		watch: {
			search() {
				clearTimeout(this.timeout);
				if(this.search.length >= 3) {
					this.timeout = setTimeout(() => {
						axios.get('/api/user?q=' + this.search).then(response => {
							this.results = response.data.data;
						})
					}, 300);
				}
			}
		},
		methods: {
			toggleChosen(user, index, target) {
				const indexOfUser = this.chosen.indexOf(user);
				if(indexOfUser === -1) {
					user.toggled = true;
					this.chosen.push(user);
				} else {
					user.toggled = false;
					this.chosen.splice(indexOfUser, 1);
				}
			}
		}
	};
</script>